import { DiscoveryInitialPanel } from '../containers/discovery-initial-panel';
import { Scene, Stage } from '@/shared/components/stage/stage';
import { FlowerSpinner } from '@/shared/components/loader/flower-spinner';
import { useDiscoveryStore } from '../stores/discovery-store';
import { DiscoverySearchContainer } from '../containers/discovery-search-container';
import { useDiscoverySessionRouting } from '../hooks/use-discovery-session';

export const DiscoveryPage = () => {
  const { viewState, session } = useDiscoveryStore();

  useDiscoverySessionRouting();

  return (
    <Stage className="bg-background flex h-screen w-full flex-col overflow-hidden">
      <Scene status={session && viewState === 'idle'} data={session}>
        {(session) => (
          <main className="flex min-h-0 flex-1 items-center justify-center px-6">
            <DiscoveryInitialPanel session={session} />
          </main>
        )}
      </Scene>
      <Scene status={session && viewState === 'chat'} data={session}>
        {(session) => <DiscoverySearchContainer session={session} />}
      </Scene>
      <Scene default className="items-center justify-center">
        <FlowerSpinner />
      </Scene>
    </Stage>
  );
};
